import * as React from "react";

const IconClose: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="currentColor"><polygon fill="currentColor" points="3.635 3.105 .53 0 0 .53 3.105 3.635 0 6.741 .53 7.27 3.635 4.165 6.741 7.27 7.27 6.741 4.165 3.635 7.27 .53 6.741 0"  transform="translate(.865 .865)"/></svg>;
};

export default React.memo(IconClose);
